<template>
<div id='presenter-main'>
  <nav-top-presenter
    :imgLeft="imgLeft"
    :img-right="imgRight"
  ></nav-top-presenter>
  <loading-animation></loading-animation>
  <div class='slide'>
    <first-page
      :loading="loadingCustomer"
      :numRefrigerators='numRefrigerators'
      :numRefrigeratorsAvailables='numRefrigeratorsAvailables'
      :numCheckIn='numCheckIn'
    ></first-page>

    <winner-slides :tickets='ticketsNotChekIn'></winner-slides>
  </div>
  <div id='load'>
    <h1>Carregando...</h1>
  </div>
</div>
</template>

<script>
// import { running } from './assets/js/function'
import NavTopPresenter from './components/NavTopPresenter'
import LoadingAnimation from './components/LoadingAnimation'
import FirstPage from './components/FirstPage'
import WinnerSlides from './components/WinnerSlides'
import './assets/fonte/stylesheet.css'
import './assets/css/bootstrap.css'
import './assets/css/style.css'

export default {
  name: 'presenter',

  components: {
    NavTopPresenter,
    LoadingAnimation,
    FirstPage,
    WinnerSlides
  },

  props: {
    imgRight: {},
    imgLeft: {},
    tickets: {
      type: Array
    },
    event: {},
    loadingCustomer: {
      required: true
    }
  },

  data () {
    return {
      status: true,
      slideIndex: 1,
      loading: true,
      cont: 0,
      currentSlide: undefined
    }
  },

  computed: {
    showPresentation () {
      return this.numRefrigerators > 0
    },

    numRefrigerators () {
      return this.tickets.length ? Number(this.tickets.length) : 0
    },

    numCheckIn () {
      return this.tickets.reduce((accum, curr) => {
        return curr.checkIn ? ++accum : accum
      }, 0)
    },

    numRefrigeratorsAvailables () {
      return this.numRefrigerators - this.numCheckIn
    },

    ticketsNotChekIn () {
      return this.tickets.filter(item => {
        return !item.checkIn
      })
    }
  },

  watch: {
    numCheckIn () {
      this.getCustomerBackIndex()
    }
  },

  methods: {
    showDivs (n) {
      this.status = false
      if (n === 1) {
        this.showFirstDiv(n)
      } else {
        this.showOthersDiv(n)
      }
      this.status = true
    },

    showFirstDiv (n) {
      let x = document.getElementsByClassName('full-page')
      if (n > x.length) {
        this.slideIndex = 1
      }
      if (n < 1) {
        this.slideIndex = x.length
      }
      for (let i = 0; i < x.length; i++) {
        x[i].style.left = Number(i * 100) + 'vw'
      }
      $('.slide')
        .css('marginLeft', ((this.slideIndex - 1) * -100) + 'vw')
    },

    showOthersDiv (n) {
      let x = document.getElementsByClassName('full-page')
      if (n > x.length) {
        this.slideIndex = 1
      }
      if (n < 1) {
        this.slideIndex = x.length
      }

      for (let i = 0; i < x.length; i++) {
        x[i].style.left = Number(i * 100) + 'vw'
      }

      $('.slide')
        .css('marginLeft', ((this.slideIndex - 1) * -100) + 'vw')
      this.status = true

      setTimeout(() => {
        this.status = true
      }, 400)
    },

    plusDivs (n) {
      this.showDivs(this.slideIndex += n)
      this.setCookie('cliente', this.slideIndex, 1)
      this.currentSlide = this.slideIndex
      this.cont = 0
      setTimeout(() => {
        $('.contemplado:eq(' + (this.slideIndex - 2) + ') .img')
          .css('opacity', '1')
        setTimeout(() => {
          $('.contemplado:eq(' + (this.slideIndex - 2) + ') .name')
            .css('opacity', '1')
          setTimeout(() => {
            $('.contemplado:eq(' + (this.slideIndex - 2) + ') .info')
              .css('opacity', '1')
            setTimeout(() => {
              $('.contemplado:eq(' + (this.slideIndex - 2) + ') .selo')
                .css('opacity', '1')
            }, 800)
          }, 800)
        }, 400)
      }, 500)
    },

    currentDiv (n) {
      this.slideIndex = n
      this.showDivs(this.slideIndex)
      setTimeout(() => {
        $('.contemplado:eq(' + (this.slideIndex - 2) + ').img')
          .css('opacity', '1')
        setTimeout(() => {
          $('.contemplado:eq(' + (this.slideIndex - 2) + ').name')
            .css('opacity', '1')
          setTimeout(() => {
            $('.contemplado:eq(' + (this.slideIndex - 2) + ').info')
              .css('opacity', '1')
            setTimeout(() => {
              $('.contemplado:eq(' + (this.slideIndex - 2) + ').selo')
                .css('opacity', '1')
            }, 800)
          }, 800)
        }, 400)
      }, 500)
    },

    getCookie (cname) {
      let name = cname + '='
      let decodedCookie = decodeURIComponent(document.cookie)
      let ca = decodedCookie.split('')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },

    setCookie (cname, cvalue, exdays) {
      let d = new Date()
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + '' + expires + 'path=/'
    },

    goNextSlide (event) {
      if (this.slideIndex < document.getElementsByClassName('full-page').length) {
        if (this.status) {
          this.status = false
          if (this.loading) {
            $('#loading')
              .css('display', 'block')
            setTimeout(() => {
              setTimeout(() => {
                $('#loading')
                  .css('opacity', '1')
              }, 400)

              setTimeout(() => {
                $('#loading')
                  .css('opacity', '0')

                setTimeout(() => {
                  $('#loading')
                    .css('display', 'none')
                }, 400)

                setTimeout(() => {
                  this.plusDivs(1)
                }, 200)

                this.loading = false
                this.status = true
              }, 6300)
            })
          } else {
            this.plusDivs(1)
          }
        } else {
          if ([37, 38, 39, 40].indexOf(event.keyCode) > -1) {
            event.preventDefault()
          }
        }
      }
    },

    goToBeginning () {
      if (this.cont === 0) {
        this.currentSlide = this.slideIndex
        this.setCookie('cliente', parseInt(this.currentSlide), 1)
        this.slideIndex = 1 // Volta pro inicio
        this.showDivs(this.slideIndex)
        this.cont++
      } else {
        // Volta para a tela onde ele parou
        this.setCookie('cliente', parseInt(this.currentSlide), 1)
        this.currentDiv(parseInt(this.currentSlide))
        this.cont = 0
      }
    },

    reloadPage () {
      this.showDivs(this.slideIndex)
      this.loading = true
      this.$emit('fetchCustomers')
      this.currentSlide = this.slideIndex
      this.slideIndex = 1
      this.showDivs(this.slideIndex)
    },

    goBackCustomerClose () {
      if (parseInt(this.getCookie('cliente')) === 1) {
        this.loading = true
        this.status = true
      } else {
        this.loading = false
        this.status = true
        if (this.numRefrigerators !== 0) {
          this.slideIndex = this.currentSlide - 1
        }
        this.goNextSlide(this.slideIndex)
      }
    },

    onKeyDown (event) {
      // if (this.loading) {
      //   if ([37, 38, 39, 40, 69, 82].indexOf(event.keyCode) > -1) {
      //     event.preventDefault()
      //   }
      // }
      if (event.keyCode === 38 || event.keyCode === 40) { // up arrow or down arrow
        return false
      }
      if (event.keyCode === 82) { // R
        this.reloadPage()
      }
      if (event.keyCode === 88) { // X
        this.goBackCustomerClose()
      }
      if (event.keyCode === 69) { // E - Volto do início
        this.goToBeginning()
      }
      if (event.keyCode === 39 && this.status) { // right arrow (->)
        this.goNextSlide(event)
      }
      // if ([37, 38, 39, 40].indexOf(event.keyCode) !== -1 && !this.status && this.loading) {
      //   event.preventDefault()
      // }
      // if (event.keyCode === 39 && this.status && !this.loading && this.slideIndex < document.getElementsByClassName('full-page').length) {
      //   this.plusDivs(1)
      // }
      if (event.keyCode === 37 && this.status && !this.loading && this.slideIndex !== 1) {
        this.plusDivs(-1)
      }
    },

    getCustomerBackIndex () {
      let current = Number(this.currentSlide)
      let index = current - this.numCheckIn
      return index <= 0 ? 1 : index
    }
  },

  mounted () {
    window.addEventListener('keydown', event => {
      this.onKeyDown(event)
    })
    this.slideIndex = this.currentSlide ? this.currentSlide : 1
  }
}
</script>



// WEBPACK FOOTER //
// src/Presenter.vue